module.exports = __webpack_public_path__ + "img/Energem_120X35.3519a052.png";